import { AsyncPipe } from '@angular/common';
import { Component } from '@angular/core';

import { PrivaLocalizationModule } from '@priva/localization';

import { AppWizardStepComponent } from 'app/features/setup-wizard/components';

import { AppWizardStep } from '../../../components';

@Component({
    selector: 'app-welcome-wizard-step',
    templateUrl: './app-welcome-wizard-step.component.html',
    imports: [AsyncPipe, PrivaLocalizationModule, AppWizardStepComponent],
})
export class AppWelcomeWizardStepComponent extends AppWizardStep {
    constructor() {
        super();
        super.setTitle('SETUP.STEP_1.TITLE');
    }
}
